<template>
    <div class="a-you-are-here you-are-here">
        <svg-icon
            v-if="!circle"
            class="you-are-here__icon"
            original
            name="guide-graphics/you-are-here"
            :color="fill || '_'"
            :fill="Boolean(fill)"
        />
        <div v-else class="circle"/>
        <span class="you-are-here__text" v-html="$t(text)" ></span>
    </div>
</template>

<script>
export default {
    name: 'AYouAreHere',
    props:{
        text: {
            type: String,
            default: 'a-you-are-here',
        },
        fill: {
            type: String,
            default: null,
        },
        circle: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style lang="scss">
@import "a-you-are-here";
</style>